module.exports = __webpack_public_path__ + "img/Outstanding_32@2x.bee822d8.png";